var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AvatarTraffic',{attrs:{"message":_vm.medium.name,"src":_vm.medium.src,"size":"20"}})
}
var staticRenderFns = []

export { render, staticRenderFns }